// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"48331564","79":"4636fb72","151":"e276585b","363":"7add634f","645":"8ee2f35e","662":"d5d64f01","719":"df4b48b9"}[chunkId] + ".chunk.js";
};